module.exports = __webpack_public_path__ + "static/media/contact-background.d5a6619a.png";